const updatePlayFeed = (state = {}, action) => {
    const {
        type = null,
        datasource,
        gumbo = {}
    } = action;

    if (type === 'dataEngine_update_response' && datasource === 'gumbo') {
        if (datasource === 'gumbo') {
            return gumbo;
        }
    }

    return state;
};

export default updatePlayFeed;
